<template>
    <div class="lnk-calendar-group">
        <div :class="getClassName">
            <el-button size="mini" type="primary" @click="allAddTask">批量设置</el-button>
        </div>
        <ul class="table-item">
            <li class="th-item">日</li>
            <li class="th-item">一</li>
            <li class="th-item">二</li>
            <li class="th-item">三</li>
            <li class="th-item">四</li>
            <li class="th-item">五</li>
            <li class="th-item">六</li>
            <li class="td-item" :key="index" v-for="(items,index) in dateNumber">
                <div v-if="items.day" class="td-item-div" @click="indeividualAddTaskDialog(items)">
                    <p class="date-number" style="position: relative;">
                        <i v-text="items.day" :class="items.day == todayNum?'checked':''"></i>
                        <el-popover placement="bottom" width="200" trigger="hover">
                            <el-row class="daily-tasks" :class="items.day >= todayNum?'task-going':''" :key="sindex" v-for="(item,sindex) in items.list">
                                <el-col :span="4" class="tasks-left">
                                    <i v-if="item.type === 'money'" class="tasks-icon" style="font-family: 'iconfont';">&#xe610;</i>
                                    <i v-if="item.type === 'something'" class="tasks-icon" style="font-family: 'iconfont';">&#xe718;</i>
                                </el-col>
                                <el-col :span="20" class="tasks-right">{{item.content}}<span v-if="item.type === 'money'">元</span></el-col>
                            </el-row>
                            <el-button v-if="items.list.length" size="mini" type="text" slot="reference" style="position: absolute;right: 10px;top: 0;">共{{items.list.length}}项</el-button>
                        </el-popover>
                    </p>
                    <el-row class="daily-tasks" :class="items.day >= todayNum?'task-going':''" v-for="(item,index) in items.list" :key="index" v-if="index < 3">
                        <el-col :span="8" class="tasks-left">
                            <i v-if="item.type === 'money'" class="tasks-icon" style="font-family: 'iconfont';">&#xe610;</i>
                            <i v-if="item.type === 'something'" class="tasks-icon" style="font-family: 'iconfont';">&#xe718;</i>
                        </el-col>
                        <el-col :span="16" class="tasks-right">{{item.content}}<span v-if="item.type === 'money'">元</span></el-col>
                    </el-row>
                </div>
            </li>
        </ul>
        <el-dialog title="设置" append-to-body :visible.sync="indeividualAddDialog" width="524px">
            <el-row :key="index" class="task-item" v-for="(item,index) in indeividualObj.list">
                <el-col v-if="item.type == 'money'" :span="4" class="task-item-title">销售目标</el-col>
                <el-col v-if="item.type == 'money'" :span="18" class="task-item-content">
                    <el-input v-model="item.content" size="mini"></el-input>元
                </el-col>
                <el-col v-if="item.type == 'something'" :span="4" class="task-item-title">日程事项</el-col>
                <el-col v-if="item.type == 'something'" :span="18" class="task-item-content">
                    <el-input v-model="item.content" size="mini"></el-input>
                </el-col>
                <el-col :span="2"  :class="getClassName">
                    <el-button size="mini" type="text" @click="deleteTask(index)">删除</el-button>
                </el-col>
            </el-row>
            <el-row :key="index" class="task-item" v-for="(item,index) in indeividualAddList">
                <el-col :span="22" class="task-item-content add-task-item-content">
                    <el-select size="mini" v-model="item.type" placeholder="任务类型">
                        <el-option label="销售目标" value="money"></el-option>
                        <el-option label="日程事项" value="something"></el-option>
                    </el-select><el-input v-model="item.content" size="mini"></el-input>
                </el-col>
                <el-col :span="2" :class="getClassName">
                    <el-button size="mini" type="text" @click="deleteAddTask(index)">删除</el-button>
                </el-col>
            </el-row>
            <el-row class="task-item">
                <el-col :span="24" class="task-item-content" :class="getClassName">
                    <el-button size="mini" type="text" icon="el-icon-plus" @click="indeividualAddTask">添加任务</el-button>
                </el-col>
            </el-row>
            <span slot="footer" :class="getClassName">
        <el-button size="mini" type="primary" @click="indeividualAddTaskSubmit()">{{$t('global.confirm')}}</el-button>
        <el-button size="mini" @click="indeividualAddDialog = false">{{$t('global.cancel')}}</el-button>
      </span>
        </el-dialog>
        <el-dialog title="批量设置" append-to-body :visible.sync="allAddDialog" width="524px">
            <el-row class="task-item">
                <el-col :span="4" class="task-item-title">日期范围</el-col>
                <el-col :span="20" class="task-item-content">
                    <el-date-picker
                        style="width: 356px;"
                        size="mini"
                        :editable="false"
                        format="yyyy-MM-dd"
                        value-format="yyyy-M-d"
                        v-model="allDate"
                        type="daterange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-col>
            </el-row>
            <el-row class="task-item">
                <el-col :span="4" class="task-item-title">排除日期</el-col>
                <el-col :span="20" class="task-item-content" style="height: 28px;line-height: 28px;">
                    <el-date-picker :disabled="allDate.length === 0" value-format="yyyy-M-d" size="mini" type="dates" v-model="allOtherDate" placeholder="选择一个或多个日期" :picker-options="otherPickerOptions"></el-date-picker>
                </el-col>
            </el-row>
            <el-row class="task-item">
                <el-col :span="4" class="task-item-title">新建任务</el-col>
                <el-col :span="20" class="task-item-content add-task-item-content">
                    <el-select style="margin-left: 0;" size="mini" v-model="allObj.type" placeholder="任务类型">
                        <el-option label="销售目标" value="money"></el-option>
                        <el-option label="日程事项" value="something"></el-option>
                    </el-select><el-input size="mini" v-model="allObj.content"></el-input>
                </el-col>
            </el-row>
            <span slot="footer" :class="getClassName">
        <el-button size="mini" type="primary" @click="allAddTaskSubmit">{{$t('global.confirm')}}</el-button>
        <el-button size="mini" @click="allAddDialog = false">{{$t('global.cancel')}}</el-button>
      </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "lnk-calendar-group",
        data: function () {
            return {
                todayNum: 0, // 当天日期存值
                dateNumber: [], // 组件日程表中日历样式方格个数控制,以及日历全部数据

                indeividualAddDialog: false, // 单个修改添加销售目标弹出框显示与隐藏
                indeividualObj: {}, // 单日修改日程弹出框中数据存储
                indeividualAddList: [], // 单日添加日程弹出框中数据储存

                allAddDialog: false, // 批量修改添加销售目标弹出框显示与隐藏
                // 禁用日期范围选择今天到月底的日期
                pickerOptions: {
                    disabledDate: (time) => time.getTime() > this.getLastDay().getTime() || time.getTime() < Date.now() - 86400000
                },
                // 通过日期范围，禁用不在范围内的其他日期用来做排除日期的选择
                otherPickerOptions: {
                    disabledDate: (time) => {
                        if(this.allDate.length !== 0){
                            var startDate = this.allDate[0].split('-');
                            var endDate = this.allDate[1].split('-');
                            var start = new Date(startDate[0], startDate[1]-1, startDate[2]);
                            var end = new Date(endDate[0], endDate[1]-1, endDate[2]);
                            return time.getTime() > end.getTime() || time.getTime() < start.getTime();
                        }
                    }
                },
                allDate: [], // 批量修改添加销售目标弹出框范围日期选择
                allOtherDate: [], // 批量修改添加销售咪表弹出框排除日期选择
                allObj: {} // 批量修改添加日程任务弹出框中任务存值
            };
        },
        props: {
            // 接收的外界传来的数据
            data: {
                type: Object,
                required: true
            },
            // 接收外界传来的控制组件样式的标识
            styleType: {
                type: String,
                default: 'dms'
            },
            // 单个日期修改添加提交前的回调函数
            beforeSubmit: {
                type: Function,
                required: true
            },
            // 批量日期添加提交前的回调函数
            beforeAllSubmit: {
                type: Function,
                required: true
            },
            // 删除原有日程任务前的回调函数
            beforeDelete: {
                type: Function,
                required: true
            }
        },
        watch: {
            // 监听外部data的变化，从而改变内部dateNumber的变化。
            data: {
                handler: function(val){
                    this.dateNumber = [];
                    this.getDateList(val.year, val.month);
                }
            }
        },

        /** 初始页面调用。*/
        mounted: function() {
            this.$nextTick(function() {
                this.getDateList(this.data.year, this.data.month);
            });
        },

        /** 计算属性。*/
        computed: {

            /** 通过标识，判断模块运用在crm或dms中，并显示与之相对应的样式。*/
            getClassName(){
                if(this.styleType == 'crm'){
                    return 'crm-color';
                }else{
                    return '';
                }
            }
        },
        methods: {

            /** 获取筛选数据，组成日历。
             * 参数year是年份，month是正常（非减一）月份。
             * */
            getDateList(year, month){
                // 初始化最初数据数组。
                for(var i=0; i<42; i++){
                    this.dateNumber.push({});
                }
                // 获取月份初日为周几。
                var d = new Date();
                d.setYear(year);
                d.setMonth(month-1);
                d.setDate(1);
                // 获取月份天数。
                var ds= new Date(year, month, 0);

                var obj = {
                    week: d.getDay(),
                    days: ds.getDate()
                };
                // 组合月份的全部日历。
                for(var i=obj.week, j=1; j<=obj.days; i++, j++){
                    Vue.set(this.dateNumber, i, {day: j, list: []});
                }
                // 将所给数据和全部日历结合得出最终日历。
                if(this.data.days){
                    for(var i=0; i<35; i++){
                        for(var j=0; j<this.data.days.length; j++){
                            if(this.dateNumber[i].day == this.data.days[j].day){
                                this.dateNumber[i] = this.data.days[j];
                            }
                        }
                    }
                }
                // 获得当天日期在几号。
                var myDate = new Date();
                if(myDate.getFullYear() < this.data.year){
                    this.todayNum = 0;
                }else if(myDate.getFullYear() === this.data.year){
                    if(myDate.getMonth() + 1 < this.data.month){
                        this.todayNum = 0;
                    }else if(myDate.getMonth() + 1 === this.data.month){
                        this.todayNum = myDate.getDate();
                    }else if(myDate.getMonth() + 1 > this.data.month){
                        this.todayNum = 40;
                    }
                }else if(myDate.getFullYear() > this.data.year){
                    this.todayNum = 40;
                }
            },

            /** 单个修改添加日程弹出框*/
            indeividualAddTaskDialog(item){
                this.indeividualObj = linkTools.deepCopy(item);
                this.indeividualAddList = [];
                this.indeividualAddDialog = true;
            },

            /** 单个修改添加日程*/
            indeividualAddTask(){
                var obj = {
                    type: '',
                    content: ''
                };
                this.indeividualAddList.push(obj);
            },

            /** 单个修改添加日程的删除*/
            deleteAddTask(index){
                this.indeividualAddList.splice(index, 1);
            },

            /** 单个修改添加日程提交*/
            indeividualAddTaskSubmit(){
                for(var i = 0; i < this.dateNumber.length; i++){
                    if(this.dateNumber[i].day === this.indeividualObj.day){
                        // 判断是否有新增的日程任务
                        if(this.indeividualAddList.length > 0){
                            // 检测新增日程任务必须不为空
                            var isListTrue = true;
                            for(var j = 0; j < this.indeividualAddList.length; j++){
                                if(!this.indeividualAddList[j].type || !this.indeividualAddList[j].content){
                                    isListTrue = false;
                                }
                            }
                            if(isListTrue){
                                var arr = this.indeividualObj.list.concat(this.indeividualAddList);
                                // 给父级传递最终数据，并通过父级return出true或false判断是否进行数组添加
                                var isFinish = this.beforeSubmit(arr);
                                if(isFinish){
                                    this.dateNumber[i].list = arr;
                                    this.indeividualAddDialog = false;
                                }
                            }else{
                                this.$message({
                                    message: '请将新增任务信息填写完整',
                                    type: 'warning'
                                });
                            }
                        }else{
                            // 无新增日程任务，提供最新修改
                            var arr = this.indeividualObj.list;
                            var isFinish = this.beforeSubmit(arr);
                            if(isFinish){
                                this.dateNumber[i].list = arr;
                                this.indeividualAddDialog = false;
                            }
                        }
                    }
                }
            },

            /** 批量添加日程弹出框*/
            allAddTask(){
                this.allDate = [];
                this.allOtherDate = [];
                this.allObj = {
                    type: '',
                    content: ''
                };
                this.allAddDialog = true;
            },

            /** 批量修改添加日程提交*/
            allAddTaskSubmit(){
                // 校验弹出框内容，时间范围是否为空，添加任务是否为空
                var isPass = true;
                if(this.allDate.length === 0){
                    isPass = false;
                    this.$message.warning('请选择日期');
                }else if(!this.allObj.type || !this.allObj.content){
                    isPass = false;
                    this.$message.warning('请将新增任务填写完整');
                }
                if(isPass){
                    // 将只有开始时间和结束时间的时间范围整理完整，并只以日期的形式存入数组中，方便后期数据整理
                    var startDate = this.allDate[0].split('-')[2];
                    var endDate = this.allDate[1].split('-')[2];
                    var arr = [];
                    for(var i = startDate; i <= endDate; i++){
                        arr.push(String(i));
                    }
                    // 将排除的日期从时间范围中剔除
                    for(var j = 0; j < this.allOtherDate.length; j++){
                        var number = this.allOtherDate[j].split('-')[2];
                        if(arr.indexOf(number)){
                            arr.splice(arr.indexOf(number), 1);
                        }
                    }
                    // 整理需要输出的数据
                    var pushDateList = []; // 选择添加的日期存值（已经剔除排除的日期）
                    var year = String(this.data.year);
                    var month = String(this.data.month);
                    if(month.length === 1){
                        month = '0' + this.data.month;
                    }
                    for(var l = 0; l < arr.length; l++){
                        var str = year + '-' + month + '-' + arr[l];
                        pushDateList.push(str);
                    }

                    var pushObj = {
                        selectedData: pushDateList, // 选择添加的日期存值（已经剔除排除的日期）
                        deleteData: this.allOtherDate, // 排除的日期列表
                        addTask: this.allObj // 添加的日程任务对象
                    };
                    // 向外部发送信息，等待外部信息返回值，进行组件内部数据变更
                    var isFinish = this.beforeAllSubmit(pushObj);
                    if(isFinish){
                        // 批量添加组建内任务
                        for(var m = 0; m < this.dateNumber.length; m++){
                            for(var n = 0; n < arr.length; n++){
                                if(this.dateNumber[m].day == arr[n]){
                                    this.dateNumber[m].list.push(linkTools.deepCopy(this.allObj));
                                }
                            }
                        }
                        this.allAddDialog = false;
                    }
                }
            },

            /** 获取当月最后一天的日期对象*/
            getLastDay(){
                var year = this.data.year;
                var month = this.data.month;
                var new_year = year; // 取当前的年份
                var new_month = month++;// 取下一个月的第一天，方便计算（最后一天不固定）
                if(month>12){ // 如果当前大于12月，则年份转到下一年
                    new_month -=12; // 月份减
                    new_year++; // 年份增
                }
                var new_date = new Date(new_year, new_month, 1); // 取当年当月中的第一天
                var lastDay = (new Date(new_date.getTime()-1000*60*60*24)).getDate();// 获取当月最后一天日期
                var myMonth = month - 2;
                var lastDate = new Date(new_year, myMonth, lastDay);
                return lastDate;
            },

            /** 删除某个日程*/
            deleteTask(index){
                var _this = this;
                this.$confirm('是否删除该日程任务?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function(){
                    var obj = _this.indeividualObj.list[index];
                    var isFinish = _this.beforeDelete(obj);
                    if(isFinish){
                        _this.indeividualObj.list.splice(index, 1);
                        _this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    }
                }).
                catch(function() {
                    _this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        }
    }
</script>

<style>
    @font-face {
        font-family: 'iconfont';  /* project id 736831 */
        src: url('//at.alicdn.com/t/font_736831_9vpibwgiq7m.eot');
        src: url('//at.alicdn.com/t/font_736831_9vpibwgiq7m.eot?#iefix') format('embedded-opentype'),
        url('//at.alicdn.com/t/font_736831_9vpibwgiq7m.woff') format('woff'),
        url('//at.alicdn.com/t/font_736831_9vpibwgiq7m.ttf') format('truetype'),
        url('//at.alicdn.com/t/font_736831_9vpibwgiq7m.svg#iconfont') format('svg');
    }
    .lnk-calendar-group{
        margin: 10px;
    }
    .lnk-calendar-group .table-item{
        width: 800px;
        height: 634px;
        border-left: 1px solid #E4E9F2;
        padding: 0;
        margin-top: 10px;
        background-color: #fff;
        color: #384250;
        font-size: 12px;
        list-style: none;
        box-sizing: border-box;
    }
    .lnk-calendar-group .table-item .th-item{
        float: left;
        box-sizing: border-box;
        width: 100px;
        padding: 8px 12px;
        border: 1px solid #E4E9F2;
        border-left: none;
        background-color: #F8F9FA;
    }
    .lnk-calendar-group .table-item .td-item{
        float: left;
        box-sizing: border-box;
        width: 100px;
        height: 100px;
        border: 1px solid #E4E9F2;
        border-top: none;
        border-left: none;
        cursor: pointer;
    }
    .lnk-calendar-group .table-item .td-item .td-item-div{
        height: 100%;
        width: 100%;
    }
    .lnk-calendar-group .table-item .td-item .td-item-div:hover{
        background-color: #ECF5FF;
    }
    .lnk-calendar-group .table-item .checkbox{
        background-color: #ECF5FF;
    }
    .lnk-calendar-group .table-item .td-item .date-number{
        margin: 0;
        padding: 2px 8px;
    }
    .lnk-calendar-group .table-item .td-item .date-number i{
        display: block;
        width: 24px;
        height: 24px;
        text-align: center;
        line-height: 24px;
        font-style: normal;
        border-radius: 50%;
    }
    .lnk-calendar-group .table-item .td-item .date-number .checked{
        background-color: #409EFF;
        color: #fff;
    }
    .el-popover{
        padding: 4px;
    }
    .daily-tasks{
        width: 100%;
        height: 22px;
        line-height: 22px;
        background-color: #84D3FF;
        border-bottom: 1px solid #fff;
    }
    .task-going{
        background-color: #FFBC4F;
    }
    .daily-tasks .tasks-left{
        text-align: center;
        height: 22px;
    }
    .daily-tasks .tasks-left .tasks-icon{
        font-style: normal;
        font-size: 24px;
        color: #fff;
    }
    .daily-tasks .tasks-right{
        text-align: right;
        padding-right:10px;
        background-color: rgba(255,255,255,.5);
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }

    /*弹出框通用样式*/
    .lnk-calendar-group .el-dialog .el-dialog__header{
        padding: 8px 16px;
    }
    .lnk-calendar-group .el-dialog .el-dialog__title{
        font-weight: normal;
    }
    .lnk-calendar-group .el-dialog .el-dialog__headerbtn{
        top: 10px;
    }
    .lnk-calendar-group .el-dialog .el-dialog__body{
        line-height: 12px;
        background-color: #F8F9FA;
        padding: 24px 20px;
    }
    .lnk-calendar-group .el-dialog .el-dialog__footer{
        text-align: center;
    }
    .lnk-calendar-group .el-dialog .el-dialog__footer .el-button{
        width: 100px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
    }
    /*批量修改销售目标任务弹出框样式*/
    .lnk-calendar-group .task-item{
        height: 28px;
        font-size: 12px;
        margin: 12px 0;
    }
    .lnk-calendar-group .task-item .task-item-title{
        text-align: right;
        line-height: 28px;
    }
    .lnk-calendar-group .task-item .task-item-content{
        padding-left: 30px;
    }
    .lnk-calendar-group .task-item .task-item-content .el-date-editor--daterange.el-input__inner{
        width: 260px;
    }
    .lnk-calendar-group .task-item .task-item-content .el-range-editor--mini .el-range-input{
        font-size: 14px;
    }
    .lnk-calendar-group .task-item .task-item-content .el-input--mini{
        width: auto;
        margin-right: 10px;
    }
    .lnk-calendar-group .task-item .task-item-content .el-input--mini .el-input__inner{
        width: 260px;
    }
    .lnk-calendar-group .task-item .task-item-content .el-date-editor--dates .el-input__inner{
        width: 356px;
    }
    /*单个修改销售目标任务弹出框样式*/
    .lnk-calendar-group .task-item .add-task-item-content .el-select--mini{
        margin-left: -14px;
    }
    .lnk-calendar-group .task-item .add-task-item-content .el-select--mini .el-input--mini{
        margin-right: 0;
    }
    .lnk-calendar-group .task-item .add-task-item-content .el-select--mini .el-input--mini .el-input__inner{
        width: 96px;
        border-right: none;
    }
    /*组件在dms/crm中样式差异*/
    .lnk-calendar-group .crm-color .el-button--text{
        color: #1F74FF ;
    }
    .lnk-calendar-group .crm-color .el-button--primary{
        background-color: #1F74FF ;
        border-color: #1F74FF ;
    }
    .lnk-calendar-group .crm-color .el-button--default:hover{
        color: #1F74FF ;
        background-color: transparent;
        border-color: #1F74FF ;
    }
</style>
